export default function CustomMarkPoint(id, point, title, subTitle) {
  this._id = id;
  this._point = point;
  this._title = title;
  this._subTitle = subTitle;
}
CustomMarkPoint.prototype = new window["BMap"].Overlay();

CustomMarkPoint.prototype.initialize = function(map) {
  this._map = map;
  const div = document.createElement("div");
  div.classList.add("bmap-custom-marker-wrapper");

  const titleSpan = document.createElement("span");
  titleSpan.classList.add("bmap-custom-marker-title");
  titleSpan.classList.add("ellipsis-2-lines");
  titleSpan.innerText = this._title;

  const subTitleSpan = document.createElement("span");
  subTitleSpan.classList.add("bmap-custom-marker-subtitle");
  subTitleSpan.classList.add("text-grey");
  subTitleSpan.classList.add("text-caption");
  subTitleSpan.classList.add("q-mt-xs");
  subTitleSpan.innerText = this._subTitle;

  const tri = document.createElement("div");
  tri.classList.add("bmap-custom-marker-tri");

  div.appendChild(titleSpan);
  div.appendChild(subTitleSpan);
  div.appendChild(tri);

  map.getPanes().markerPane.appendChild(div);
  // 保存div实例
  this._div = div;
  // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
  // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
  return div;
};

// 实现绘制方法
CustomMarkPoint.prototype.draw = function() {
  // 根据地理坐标转换为像素坐标，并设置给容器
  var position = this._map.pointToOverlayPixel(this._point);
  this._div.style.left = `${position.x}px`;
  this._div.style.top = `${position.y}px`;
  // this._div.style.transform = `translate(-50%, calc(-100% - 20px))`;
};

CustomMarkPoint.prototype.addEventListener = function(eventType, callback) {
  this._div.addEventListener(eventType, (event) => {
    callback(event, this);
  });
};
